import PageHero from '../components/ui/PageHero';
import LegalContent from '../components/ui/LegalContent';
import { company } from '../data/company';

const sections = [
  {
    heading: '1. Information We Collect',
    paragraphs: [
      'We collect information you provide directly to us, such as when you:',
    ],
    list: [
      'Create an account or use our services',
      'Contact us through our website or support channels',
      'Subscribe to our newsletters or marketing communications',
      'Participate in surveys, contests, or promotional activities',
    ],
  },
  {
    heading: '2. How We Use Your Information',
    paragraphs: ['We use the information we collect to:'],
    list: [
      'Provide, maintain, and improve our field-service and maintenance operations platform',
      'Process transactions and send related information',
      'Send technical notices, updates, security alerts, and support messages',
      'Respond to your comments, questions, and customer service requests',
      'Communicate with you about products, services, offers, and events',
      'Monitor and analyze trends, usage, and activities in connection with our services',
    ],
  },
  {
    heading: '3. Information Sharing and Disclosure',
    paragraphs: [
      'We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in this policy:',
    ],
    list: [
      'Service Providers: We may share information with third-party vendors who perform services on our behalf',
      'Legal Requirements: We may disclose information if required by law or to protect our rights',
      'Business Transfers: Information may be transferred in connection with a merger, acquisition, or sale of assets',
      'Data Security: Tecnvirons does not share or sell customers’ mobile phone numbers or SMS opt-in consent data with third parties for marketing or promotional activities',
    ],
  },
  {
    heading: '4. Data Security',
    paragraphs: [
      'We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure.',
    ],
  },
  {
    heading: '5. Your Rights and Choices',
    paragraphs: ['You have the right to:'],
    list: [
      'Access, update, or delete your personal information',
      'Opt-out of marketing communications',
      'Request a copy of your data',
      'Object to processing of your personal information',
    ],
  },
  {
    heading: '6. Cookies and Tracking Technologies',
    paragraphs: [
      'We use cookies and similar tracking technologies to collect and use information about how you interact with our website and services, so we can keep improving them.',
    ],
  },
  {
    heading: '7. International Data Transfers',
    paragraphs: [
      'Your information may be transferred to and processed in countries other than your own — including between our India and USA offices. We ensure appropriate safeguards are in place to protect your personal information wherever it is processed.',
    ],
  },
  {
    heading: '8. Changes to This Policy',
    paragraphs: [
      'We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date above.',
    ],
  },
  {
    heading: '9. Contact Us',
    paragraphs: [
      'If you have any questions about this Privacy Policy, please contact us:',
      `Email: ${company.email}`,
      ...company.offices.map((o) => `${o.label} — ${o.legalName}, ${o.address} — ${o.phone}`),
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <div>
      <PageHero
        eyebrow="Privacy Policy"
        title="Your privacy, protected by design."
        body="Learn how we collect, use, and protect your information across our field-service and maintenance operations platform."
      />
      <LegalContent
        intro="At Tecnvirons, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you use our platform, including the Tecnvi Ongo and Tecnvi Connect companion apps."
        sections={sections}
      />
    </div>
  );
}
